import { actions as ACTION } from "./types";
import { Api, ApiUrl } from "../../services";
const actions = {
  [ACTION.TEMPLATE_ACCEPT_IMPORT](store, data) {
    let statusControl = store.state.status.import;
    return new Promise(async (resolve, reject) => {
      statusControl.loading = true;

      try {
        data = await Api.base.post(ApiUrl.base.template.import, {
          code: data.code
        });

        if (data.status) {
          resolve(data);

          statusControl.success = true;
          setTimeout(() => {
            statusControl.success = false;
          }, 1500);
        } else {
          throw data;
        }
      } catch (err) {
        reject(err);

        statusControl.error = true;

        setTimeout(() => {
          statusControl.error = false;
        }, 1500);
      }

      statusControl.loading = false;
    });
  }
};

export default actions;
